import { Pipe, PipeTransform } from '@angular/core';

/** Relative label for a timestamp ('just now', 'Nm ago', 'Nh ago', else the
 * locale date). `now` is an explicit argument so the pipe stays pure: the host
 * feeds a ticking signal and the label ages under OnPush. */
@Pipe({ name: 'askRynRelativeTime' })
export class AskRynRelativeTimePipe implements PipeTransform {
  transform(ts: string, now: number): string {
    const d = new Date(ts);
    const diffMs = now - d.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    return d.toLocaleDateString();
  }
}
